(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Sso",
                {
                    url: "/Sso?{accesstoken}&{onbehalfofuserid}&{expiration}&{marketplaceenvironment}&{resourcesubstate}",
                    component: "sso"
                });
        }
    ]);

    app.component("sso",
        {
            controller: ssoController
        });

    ssoController.$inject = ["$stateParams", "$state", "permissionService", "marketplaceOneApi", "marketplaceOneSettings", "portalApiGateway"];

    function ssoController($stateParams, $state, permissionService, marketplaceOneApi, marketplaceOneSettings, portalApiGateway) {
        var headers = { "Authorization": "Bearer " + $stateParams.accesstoken };
        if ($stateParams.onbehalfofuserid)
            headers["X-On-Behalf-Of"] = $stateParams.onbehalfofuserid;

        portalApiGateway.post("/Login/SwitchAuth", {}, { headers: headers })
            .then(function () {

                permissionService.removeStoredPermissions();
                permissionService.removeStoredOnBehalfOfUserId();

                if ($stateParams.onbehalfofuserid)
                    permissionService.setOnBehalfOfUserId($stateParams.onbehalfofuserid);

                if ($stateParams.marketplaceenvironment) {
                    marketplaceOneApi.getToken().then(function (token) {
                        // var expiration = localStorage.getItem("Auth.Expiration");
                        var now = new Date();
                        now.setTime(now.getTime() + 45 * 60 * 1000);
                        var expiration = now.toISOString();
                        var url = marketplaceOneSettings.baseUrl +
                            "!/Sso?accesstoken=" +
                            token +
                            "&expiration=" + expiration;
                        if ($stateParams.onbehalfofuserid) url += "&onBehalfOfUserId=" + $stateParams.onbehalfofuserid;
                        window.location.href = url;
                    });

                } else if ($stateParams.resourcesubstate){
                    $state.go("Home.Resources." + $stateParams.resourcesubstate);
                } else {
                    $state.go("Home.Dashboard");
                }
            });
    }
})(window.app); //jshint ignore:line